// extracted by mini-css-extract-plugin
export default {"inputApply":"InputApply_inputApply__fgg4+"};